import { render, staticRenderFns } from "./panel_waitReceive.vue?vue&type=template&id=d5275e2a&scoped=true&"
import script from "./panel_waitReceive.vue?vue&type=script&lang=js&"
export * from "./panel_waitReceive.vue?vue&type=script&lang=js&"
import style0 from "./panel_waitReceive.vue?vue&type=style&index=0&id=d5275e2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5275e2a",
  null
  
)

export default component.exports